import type { ReactElement, ReactNode } from 'react';
import styled, { useTheme } from 'styled-components';

import { Button } from '../Button';

import { RepeatBlock } from './RepeatBlock';

export const StyledTitle = styled.div(({ theme: { fonts, indents } }) => ({
  ...fonts.H3,
  marginBottom: indents.INDENT_3,
}));

export const StyledAdd = styled.div(({ theme: { repeat } }) => ({
  textAlign: 'right',
  marginTop: repeat.ADD_BUTTON_MARGIN_TOP,
}));

export type RepeatProps = {
  /**
   * Выключена ли кнопка добавления
   */
  disabled?: boolean;

  /**
   * Заголовок
   */
  title?: ReactNode;

  /**
   * Текст кнопки добавления
   */
  addButtonTitle?: ReactNode;

  /**
   * Обработчик нажания на кнопку добавления, если не определён, кнопка добавления не отображается
   */
  handleAdd?: () => void;

  children?: ReactNode;
};

export function Repeat({
  addButtonTitle = 'Добавить ещё',
  disabled = false,
  children = undefined,
  handleAdd = undefined,
  title = undefined,
}: RepeatProps): ReactElement {
  const { repeat } = useTheme();

  return (
    <div>
      {title && <StyledTitle>{title}</StyledTitle>}

      {children}

      {handleAdd && (
        <StyledAdd>
          <Button
            size="small"
            color={repeat.ADD_BUTTON_COLOR}
            componentProps={{
              type: 'button',
            }}
            disabled={disabled}
            onClick={handleAdd}
          >
            {addButtonTitle}
          </Button>
        </StyledAdd>
      )}
    </div>
  );
}

Repeat.Block = RepeatBlock;
